import { useBeneficiariesGridHeaders } from '@/domain/payments/queries';

const useFetchColumnDefs = () => {
  const { data, isLoading, isFetched } = useBeneficiariesGridHeaders();
  return {
    vendorColumnDefs: data?.vendor ?? [],
    beneficiaryColumnDefs: data?.beneficiary ?? [],
    rawColumnDefsIsBusy: isLoading,
    rawColumnDefsIsFetched: isFetched,
  };
};

export default useFetchColumnDefs;
